import closeIcon from '@/assets/icon/close-icon.svg';
import Button from '@/shared/components/ui/Button';


interface DetailInfoModalLogProps {
  isOpen?: boolean;
  onClose: () => void;
  logData?: Record<string, any>;
}

const DetailInfoModalLog = ({ isOpen, onClose, logData }: DetailInfoModalLogProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[1000]">
      <div className="w-[30%] flex flex-col  bg-db-card border border-[#D6DBE1] rounded-[5px] overflow-hidden">
        <div className="w-full py-2 flex flex-row justify-between px-3 bg-[#135A78] dark:bg-db-black">
          <span className="title2 text-text-white">상세 내용</span>
          <Button
            variant="ghost"
            type="button"
            className="w-6 h-6 p-0 hover:bg-transparent cursor-pointer"
            onClick={onClose}
          >
            <img src={closeIcon} style={{ filter: 'invert(1)' }} alt="close" />
          </Button>
        </div>

        <div className="flex flex-col p-3 h-[350px] overflow-hidden">
          <div className=" border border-accent-foreground w-full h-full overflow-auto p-3">
            <pre className="text-sm whitespace-pre-wrap break-words">
              {JSON.stringify(logData, null, 2)}
            </pre>
          </div>
        </div>

        <div className="w-full flex justify-center pb-2 items-center m-auto ">
          <Button customButton="btn-search w-fit " label="닫기" onClick={onClose} />
        </div>
      </div>
    </div>
  );
};

export default DetailInfoModalLog;
